import type React from 'react';
import styled from 'styled-components';

const SubsectionPreviewWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 6px 12px;
  position: relative;
  min-height: 40px;
  border-radius: ${props => props.theme.borderRadius}px;

  background-color: ${props => props.theme.colorPrimaryBorder};
`;

export interface ISubsectionPreviewContainerProps {
  children?: React.ReactNode;
}
/**
 * Parte
 */
export function SubsectionPreviewContainer(
  props: ISubsectionPreviewContainerProps,
) {
  const { children } = props;
  return <SubsectionPreviewWrapper>{children}</SubsectionPreviewWrapper>;
}
